"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }// src/common-components/lib/click-point.tsx
var _react = require('react'); var _react2 = _interopRequireDefault(_react);
function ClickPoint({ x = 0, y = 0, cls = "" }) {
  return /* @__PURE__ */ _react2.default.createElement("div", { className: cls, style: { left: `${x * 100}%`, top: `${y * 100}%` } });
}



exports.ClickPoint = ClickPoint;
//# sourceMappingURL=chunk-WAWENPZM.js.map